import $ from 'jquery';
import mq from '../utils/mediaQueries';

const openFlag = 'nav-expanded';
const openClass = `.${openFlag}`;
const parentClass = '.main-nav__item--parent';
const dropdownTrigger = '.main-nav__item--parent > .main-nav__link';

export default {

  _bindEvents() {

    const parentLinks = document.querySelectorAll(dropdownTrigger);
    [].forEach.call(parentLinks, parentLink => {
      parentLink.addEventListener('click', e => {
        e.preventDefault();
        this.toggle(parentLink.parentNode);
      });
    });

    $(document).on('click', e => {
      if ( !$(e.target).closest(openClass).length ) this.closeAll();
    });

    document.addEventListener('keydown', e => {
      if ( e.key == 'Escape' ) this.closeAll();
    });

    mq.maxWidth('nav', () => this.closeAll());
  },

  init() {
    this._bindEvents();
  },

  isOpen(el) {
    return el.classList.contains(openFlag)
  },

  toggle(el) {
    el.classList.toggle(openFlag)
  },

  open(el) {
    el.classList.add(openFlag)
  },

  close(el) {
    el.classList.remove(openFlag)
  },

  closeAll() {
    const openMenus = document.querySelectorAll(openClass);
    [].forEach.call( openMenus, expanded => this.close(expanded) );
  }

}
